import { createSelector } from '@reduxjs/toolkit';

import { FooterState } from '@definitions/footer.types';

import { GlobalState } from '../createStore';

export const selectFooterDomain = (state: GlobalState) => state.footer;

export const selectFooterLinks = createSelector(selectFooterDomain, (state: FooterState) => state.links);
